<template>
  <div class="main">
    <div class="left_main">
      <h2>服务门店列表</h2>
      <div class="box">
        <el-button class="add_service_stores" @click="addAServiceStore" type="primary">添加服务商店</el-button>
        <el-input
          class="store_search"
          size="small"
          clearable
          @change="searchShopName"
          placeholder="请输入商店名称过滤"
          suffix-icon="el-icon-search"
          v-model="shopName">
        </el-input>
        <ul>

          <li v-for="(item, index) in listOfServiceOutlets" :key="index" :class="{shutDown:item.isEnabled == 'close', active: index == activeIndex}" @click="liClick(item,index)">
            <div class="stores_name_box flex"><p class="store_name">{{ item.shopName}}</p><p class="state">{{ item.isEnabled == 'open'? '开启':'关闭' }}</p></div>
            <div class="start_flex">
              <template v-if="item.serviceNameListArrs && item.serviceNameListArrs.length > 0">
                <p :title="item.serviceNameListArrs[0]">{{item.serviceNameListArrs[0]}}</p>
                <p :title="item.serviceNameListArrs[1]" v-if="item.serviceNameListArrs.length > 1">{{item.serviceNameListArrs[1]}}</p>
                <p :title="item.serviceNameList" v-if="item.serviceNameListArrs.length > 2" style="width: 20px;">...</p>
              </template>
            </div>
            <el-popover
              class="three"
              placement="bottom"
              trigger="click"
              >
              <p @click="modifyTheEnabledStatus(item)" style="width: 100px; cursor: pointer;">修改启用状态</p>
              <el-button slot="reference" style="border: none;background: none;"><i class="el-icon-more" style="transform: rotate(90deg); color: #8a8a8a;"></i></el-button>
            </el-popover>
          </li>


        </ul>
      </div>
    </div>

    <div class="right_box">
      <div class="headers flex_center">
        <div>
          <el-button type="primary" @click="openDialogVisibleEmp()" size="small">新增技师</el-button>
          <el-button style="background: #17A21D;color: #ffffff;" @click="setUpServiceCapabilities()" size="small">批量设置服务范围</el-button>
        </div>
        <div>
          <el-input v-model="keyWord" style="width: 280px; margin-right: 20px" size="small" clearable placeholder="请输入技师姓名/工号"></el-input>
          <el-button type="primary" size="small" @click="getAListOfTechnicians">查询</el-button>
        </div>
      </div>

      <el-table
        stripe
        border
        :data="serviceProject"
        style="width: 100%;margin-top: 20px"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="工号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="账号"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="secondLevelNames"
          label="可约服务"
        ></el-table-column>
    
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
          width="300px"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                @click="editorialTechnicianServices(scope.row)"
                size="small"
                >编辑服务范围</el-button> 
                <el-button
                type="text"
                class="blue"
                @click="scheduledLeaveSettings(scope.row)"
                size="small"
                >排休设置</el-button>

                <el-button
                type="text"
                class="blue"
                @click="editTheTechnicianBackground(scope.row)"
                size="small"
                >编辑技师背景</el-button>

              </div>
              <div class="flex flex-center item-center">

              <span style="margin: 0 10px;">启用状态</span>
              <el-switch
                v-model="scope.row.isEnabled"
                @change="switchChange(scope.row)"
                active-color="#13ce66"
                active-text="开启"
                inactive-text="关闭">
              </el-switch>
            </div>
            
          </template>
        </el-table-column>
      </el-table>

      <div class="hm-pagination" v-if="total > pageSize">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>


    </div>


    <!-- 新增门店 -->
    <el-dialog
      title="添加商店"
      :visible.sync="dialogVisibleAddAStore"
      width="1230px"
      >
      <storesTable ref="storesTables" @getTheSelectedStore="getTheSelectedStore"></storesTable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddAStore = false">取 消</el-button>
        <el-button type="primary" @click="storesTableAreYouSure">确 定</el-button>
      </span>
    </el-dialog>
    

    <!-- 新增技师 -->
    <hm-filter-employee
      selectType="multiple"
      v-if="dialogVisibleEmp"
      @handleClickScopeOfAppointments="handleClickScopeOfAppointments"
      @setMultipleEmpInfo="setMultipleEmpInfo"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
      :isRole="true"
    ></hm-filter-employee>



    <!-- 可预约范围 -->
    <el-dialog
      title="设置服务范围"
      :visible.sync="dialogVisibleScopeOfAppointments"
      width="1230px"
      >

      <ul class="scope-of-appointments-ul">
        <template v-for="item in scopeOfAppointmentsList">
          <li :key="item.id" v-if="item.storeServiceRestorationTypeSecondLevelModelList && item.storeServiceRestorationTypeSecondLevelModelList.length > 0">
            <h3 class="lable_h3"><p>{{item.serviceType}}</p></h3>
            <el-checkbox-group v-model="item.secondLevelId">
              <el-checkbox v-for="v in item.storeServiceRestorationTypeSecondLevelModelList" :key="v.id" :label="v.id" >{{v.serviceName}}</el-checkbox>
            </el-checkbox-group>
          </li>
        </template>
        

      </ul>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleScopeOfAppointments = false;serviceStaffId=''">取 消</el-button>
        <el-button type="primary" @click="appointmentConfirmed">确 定</el-button>
      </span>
    </el-dialog>



    <el-dialog
      title="修改门店状态"
      :visible.sync="storeStatusPopUp"
      width="600px"
      >
      <div>
        <p style="margin-bottom: 20px;">启用状态</p>
        <el-switch
          style="display: block"
          v-model="isEnabled"
          active-color="#13ce66"
          active-text="开启"
          inactive-text="关闭">
        </el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="storeStatusPopUp = false" size="small">取 消</el-button>
        <el-button type="primary" @click="storeStatusSubmission" size="small">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 设置服务能力 -->
    <el-dialog
      title="批量设置服务范围"
      :visible.sync="serviceScopePopUpWindow"
      width="1000px"
      >

      <div class="scopeOfServices" v-if="listOfBulkServiceCapabilities && listOfBulkServiceCapabilities.length > 0">
        <div class="left_box scrollable-area">
          <div class="li" 
            v-for="(item, index) in listOfBulkServiceCapabilities" 
            :class="{active: index == batchActiveIndex}" 
            :key="item.id"
            @click="serviceClicks(item, index)"
            >
            <p>{{item.serviceName}}</p>
            <p v-show="item.selectedNumber > 0">{{item.selectedNumber}}</p>
          </div>
        </div>
        <div class="right_box_scope">
          <el-checkbox-group v-model="listOfBulkServiceCapabilities[batchActiveIndex].serveCheckbox" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in listOfCompetenciesToTheRight" :key="item.id" :label="item.id" style="margin-bottom: 10px;">{{item.realName}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="serviceScopePopUpWindow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="bulkSubmissions" size="small">确 定</el-button>
      </span>
    </el-dialog>


      <el-dialog
        title="设置休息日"
        :visible.sync="calendarPopUp"
        width="600px"
      >
        <div style="width: 100%; display: flex;">
          <Calendar :storageData="storageData" :calendarData="calendarData" :key="initNum" @submitServe="submitServe" ref="calendar"/>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="calendarPopUp = false" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmationOfScheduledLeave" size="small">确 定</el-button>
        </span>
      </el-dialog>


      <el-dialog
        title="技师背景设置"
        :close-on-click-modal="false"
        :visible.sync="AddDialogVisible"
      >
        <div class="text-left">
          <el-form
            :model="serviceForm"
            ref="serviceForm"
            label-width="200px"
            :rules="rules"
          >
            <el-form-item label="技师姓名" prop="realName">
              <el-input
                clearable
                @mousewheel.prevent.native
                v-model.trim="serviceForm.realName"
                size="small"
                disabled
                class="ipt mr10"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="职位" prop="staffPosition">
              <el-input
                clearable
                @mousewheel.prevent.native
                v-model="serviceForm.staffPosition"
                placeholder="请输入职位"
                size="small"
                class="ipt mr10"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="头像">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="200"
                :height="200"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mall' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              
              <el-button
                type="primary"
                size="small"
                v-show="!serviceForm.staffProfileImg"
                @click="toggleShow"
                >上传</el-button
              >
              <span class="form-tip"
                >图片尺寸建议200x200（最多上传一张）</span
              >
              <div class="priview" v-if="serviceForm.staffProfileImg">
                <img :src="serviceForm.staffProfileImg" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow">更换</el-button>
                </div>
              </div>
            </el-form-item>


            
            <el-form-item label="个人简介">
              <el-input
                type="textarea"
                placeholder="请简要介绍您的专业背景和技能特长"
                v-model="serviceForm.staffPersonal"
                show-word-limit
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="服务客户数:" prop="serviceCustomerNumber">
              <el-input
                v-model.number="serviceForm.serviceCustomerNumber"
                placeholder="请输入服务过的客户数量"
                show-word-limit
                size="small"
              ></el-input>
              <!-- <p>数字，不能有负数和小数</p> -->
            </el-form-item>

            <el-form-item label="从业年数:" prop="serviceDuration">
              <el-input
                v-model.number="serviceForm.serviceDuration"
                size="small"
                placeholder="请输入从业年数"
                show-word-limit
              ></el-input>
              <!-- <P>数字，不能有负数和小数</P> -->
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="saveService('serviceForm', 'edit')"
                >保存</el-button
              >
              <el-button size="small" @click="AddDialogVisible = false"
                >取消</el-button
              >
            </div>
          </el-form>
        </div>
      </el-dialog>




  </div>
</template>
<script>
import HmFilterEmployee from "../components/HmFilterEmployee";
import Calendar from "@/components/Calendar.vue";
import storesTable from "../components/storesTable";
import myUpload from "vue-image-crop-upload";
import { number } from 'echarts/lib/export';


export default {
  components: {HmFilterEmployee, storesTable, Calendar, myUpload},
  data() {
    return {
      selectedDate:'',
      AddDialogVisible: false,
      show: false,
      serviceForm: {
        id: "",
        staffPosition:'',
        staffProfileImg:'',
        staffPersonal:'',
        serviceCustomerNumber:'',
        serviceDuration:''
      },
      rules: {
        // serviceType: [
        //   { required: true, message: "请输入服务类型", trigger: "blur" },
        // ],
        // staffProfileImg: [
        //   { required: true, message: "请上传默认图标", trigger: "change" },
        // ],
        serviceDuration: [
          { type: 'number', message: '必须为数字值'},
          {
            validator: this.validatePositiveInteger,
            trigger: 'blur'
          }
        ],
        serviceCustomerNumber: [
          { type: 'number', message: '必须为数字值'},
          {
            validator: this.validatePositiveInteger,
            trigger: 'blur'
          }
        ],
        // serviceIconChecked: [
        //   { required: true, message: "请上传选中图标", trigger: "change" },
        // ],
      },
      calendarPopUp:false,
      initNum:0,
      calendarData:{},
      storageData:[],
      listOfCompetenciesToTheRight:[],
      batchActiveIndex: 0,
      listOfBulkServiceCapabilities:[],
      serveCheckbox: [],
      serviceScopePopUpWindow: false,
      staffSecondLevelIdList: [],
      scopeOfAppointmentsList:[],
      shopName:'',
      activeIndex: 0,
      init: false,
      statusOfASinglePieceOfData:{},
      listOfServiceOutlets:[],
      isEnabled: false,
      storeStatusPopUp: false,
      selectedStore:[],
      scopeOfAppointments:'', // 预约范围
      keyWord:'',
      dialogVisibleAddAStore: false,
      dialogVisibleScopeOfAppointments:false,
      pageSize: 10,
      currentPage:1,
      total: 1,
      dialogVisibleEmp: false,
      keyWord:'',
      shopId:'',
      serviceStaffId: '',
      checkedRowList:[],
      serviceProject:[
   
      ],
    };
  },
  created() {
    this.getTheStoreList();
  },
  mounted() {
    this.getTheRangeOfAppointmentsAvailable();
  },
  methods: {
    validatePositiveInteger(rule, value, callback) {
      // 判断是否为正整数
      if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error('必须是正整数'));
      } else {
        callback();
      }
    },
    // 保存
    async saveService(formName, type) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = this.serviceForm;
        console.log(params);
        const { code } = await this.$store.dispatch('storeServiceTechnicianStaffEdit', params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.AddDialogVisible = false;
          this.currentPage = 1;
          this.getAListOfTechnicians();
        }
        
      }else {
        this.$message({
          message: "请检查输入项是否正确",
          type: "warning",
        });
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.serviceForm.staffProfileImg = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    // 编辑技师背景
    async editTheTechnicianBackground(row){
      const { result } = await this.$store.dispatch("technicianStaffQueryById", {
        id: row.id,
        shopId: this.shopId
      });
      this.serviceForm = {
        realName: result.realName,
        id: result.id,
        staffPosition: result.staffPosition,
        staffProfileImg: result.staffProfileImg,
        staffPersonal: result.staffPersonal,
        serviceCustomerNumber: Number(result.serviceCustomerNumber),
        serviceDuration: Number(result.serviceDuration)
      },
      this.AddDialogVisible = true;
    },
    confirmationOfScheduledLeave(){
      if(this.$refs.calendar){
        this.$refs.calendar.submitEvent();
      }
    },
    async submitServe(val){
      const {code} = await this.$store.dispatch("addStaffReposeDate", {
        shopId: this.calendarData.shopId,
        employeeId: this.calendarData.employeeId,
        reposeDateRuleList: val
      });
      if(code == 0){
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.calendarPopUp = false;
      }
    },
    // 排休设置
    async scheduledLeaveSettings(row){
      this.storageData = [];
      this.calendarData = row;
      const { result } = await this.$store.dispatch("getStaffReposeDateList", {
        shopId: row.shopId,
        employeeId: row.employeeId,
      });
      const { reposeDateList } = result;
      if(reposeDateList && reposeDateList.length> 0){
        this.storageData = reposeDateList.map(v=>v.slice(0, 10));
      }
      this.initNum++;
      this.calendarPopUp = true;
    },
    // 批量提交
    async bulkSubmissions(){
      console.log(this.listOfBulkServiceCapabilities);
      let storeServiceShopProjectRelStaffAddBatch = [...this.listOfBulkServiceCapabilities]
      storeServiceShopProjectRelStaffAddBatch.forEach(e=> {
        e.serviceStaffIdList = e.serveCheckbox;
        e.projectId = e.id;
      })

      const { code } = await this.$store.dispatch("updateServiceStaffIdsBySecondLevelList", {
        shopId: this.shopId,
        storeServiceShopProjectRelStaffAddBatch,
      });

      if(code == "0"){
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.serviceScopePopUpWindow = false;
        this.getAListOfTechnicians();
      }

    },
    handleCheckedCitiesChange(val){
      this.listOfBulkServiceCapabilities[this.batchActiveIndex].selectedNumber = val.length;
    },

    serviceClicks(row, index){
      this.batchActiveIndex = index;
      this.listOfCompetenciesToTheRight = row.projectStaffModel;
    },
     // 设置服务能力
    async setUpServiceCapabilities(){
      this.serviceScopePopUpWindow = true;
      const { result } = await this.$store.dispatch("queryLevelServiceShopProjectStaffList",{
        shopId: this.shopId,
      });
      console.log("result:", result)
      if(result && result.length > 0){
        result.forEach(e=>{
          e['serveCheckbox'] = [];
          e.projectStaffModel.forEach(v=> {
            if(v.isSelect == 'yes'){
              e.serveCheckbox.push(v.id);
            }
          })
          console.log(e.serveCheckbox)
        })
        this.listOfBulkServiceCapabilities = result;
        this.listOfCompetenciesToTheRight = result[0].projectStaffModel;
      }
    },

    // 添加服务门店需要重置
    addAServiceStore(){
      this.dialogVisibleAddAStore = true;
      this.$nextTick(() => {
        if (this.$refs.storesTables) {
          this.$refs.storesTables.resetTheData();
          this.$refs.storesTables.queryList();
        }
      });
    },
    // 获取可预约范围queryLevelServiceRestorationTypeList
    async getTheRangeOfAppointmentsAvailable(){
      const { result } = await this.$store.dispatch("queryLevelServiceRestorationTypeList");
      if(result){
        console.log("result222222222:", result)

        result.forEach(e=> {
          e.secondLevelId = [];
        })
        this.scopeOfAppointmentsList = result;
      }
    },
    switchChange(val){
      this.$store.dispatch("updateStaffIsEnabled", {
        id: val.id,
        isEnabled: val.isEnabled ? "open" : "close"
      });
    },
     // 编辑
     editorialTechnicianServices(row){
      console.log(row);
      // 编辑时应该重新归零
      this.serviceStaffId = row.id;
      this.staffSecondLevelIdList = row.staffSecondLevelIdList;

      this.scopeOfAppointmentsList.forEach(e=> {  
        e.secondLevelId = [];
      })
      this.scopeOfAppointmentsList.forEach(e=> {  
        e.storeServiceRestorationTypeSecondLevelModelList.forEach(v=> {
          if(row.staffSecondLevelIdList && row.staffSecondLevelIdList.length > 0){
            row.staffSecondLevelIdList.forEach(i=> {
              if(i == v.id){
                e.secondLevelId.push(i);
              }
            })
          }
        });
      })
      this.dialogVisibleScopeOfAppointments = true;
    },
    // 新增技师提交
    async appointmentConfirmed(){
      console.log("预约范围");
      let secondLevelIdList = [];
      this.scopeOfAppointmentsList.forEach(e=>{
        if(e.secondLevelId.length>0){
           e.secondLevelId.forEach(v=> {
              secondLevelIdList.push(v);
            })
        }
      });

       let checkedRowList = [...this.checkedRowList];
       let employeeIdList = [];


      //  这地方的shopId是选中的门店的id
       checkedRowList.forEach(v=> {
         employeeIdList.push({shopId: this.shopId,employeeId: v.employeeId})
       })

       let url = 'addATechnician'; // 新增
       let params = {
          employeeIdList,
          secondLevelIds: secondLevelIdList, // 这里是多选框
        };
        console.log(this.serviceStaffId);
       if(this.serviceStaffId){ // 编辑
         url = 'updateServiceStaffBySecondLevelList';
         params = {
          serviceStaffId: this.serviceStaffId,//工号
          secondLevelIds: secondLevelIdList, //可约服务
          shopId: this.shopId,
         }
       }

      // 新增接口
      const { code } = await this.$store.dispatch(url, params)
      if(code == "0"){
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        // 清空技师选择的数据
        this.checkedRowList = [];
        // 清空多选框的数据
        this.scopeOfAppointmentsList.forEach(e=> {
          e.secondLevelId = [];          
        });
        this.serviceStaffId = ''; // 清除编辑的工号
        this.dialogVisibleScopeOfAppointments = false;
        this.getAListOfTechnicians();

      }
    },
    // 预约范围显示
    async handleClickScopeOfAppointments(isShow, newval) {
      console.log("isShow:", isShow);
      let employeeIdList = [];
      this.checkedRowList = newval;
      //  这地方的shopId是选中的门店的id
      this.checkedRowList.forEach(v=> {
        employeeIdList.push({shopId: this.shopId,employeeId: v.employeeId})
      })
      const { code } = await this.$store.dispatch("addATechnician", {
        employeeIdList,
      });

      if(code == "0"){
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.dialogVisibleEmp = false;
        this.getAListOfTechnicians();
      }

      // this.dialogVisibleScopeOfAppointments = isShow;
    },
    // 点击列表
    liClick(row, index){
      this.activeIndex = index;
      this.shopId = row.shopId;
      console.log(this.shopId);
      this.getAListOfTechnicians();
    },
    // 获取技师列表
    async getAListOfTechnicians(){
      const { result } = await this.$store.dispatch("getAListOfTechnicians",{
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWord: this.keyWord,
        shopId: this.shopId,
      });

      if(result){
        console.log("result:", result)
        const { total, records } = result;
        records.forEach(item => {
          item.isEnabled = item.isEnabled == "open"? true : false;
        });
        this.serviceProject = records;
        this.total = total;
      }

    },
    paging(page) {
      this.currentPage = page;
      this.getAListOfTechnicians();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getAListOfTechnicians();
    },

    async storeStatusSubmission(){
      const { code } = await this.$store.dispatch("updateServiceShopIsEnable", {
        id: this.statusOfASinglePieceOfData.id,
        isEnabled: this.isEnabled? "open" : "close"
      });
      if(code == 0){
        this.storeStatusPopUp = false;
        this.getTheStoreList();
      }
    },
    modifyTheEnabledStatus(row){
      this.statusOfASinglePieceOfData = row;
      this.isEnabled = this.statusOfASinglePieceOfData.isEnabled == "open"? true : false;

      this.storeStatusPopUp = true;
    },
    searchShopName(){
      this.getTheStoreList();
    },
    // 获取服务门店列表
    async getTheStoreList(){
      const { result } = await this.$store.dispatch("listOfStoresToMakeAppointments", {
        shopName: this.shopName
      });

      if(result){
        result.forEach(e=> {
          // 字符串转数组
          if(e.serviceNameList){
            e.serviceNameListArrs = e.serviceNameList.split(",");
          }
        })
        this.listOfServiceOutlets = result;
        this.shopId = result[0].shopId;
        this.getAListOfTechnicians();
      }
    },
   
   
    // 获取选中门店
    getTheSelectedStore(val){
      this.selectedStore = val;
    },
    // 添加门店 确定 
    async storesTableAreYouSure(){
      if(this.selectedStore.length == 0){
        this.$message({
            message: "请选择门店",
            type: "error",
          });
        return;
      }
      const { code } = await this.$store.dispatch("storeServiceShopAdd", {
        storeServiceShopModelList: this.selectedStore
      });

       if(code == 0){
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getTheStoreList();
          this.dialogVisibleAddAStore = false;
       }
    },
  


    openDialogVisibleEmp() {
      this.dialogVisibleEmp = true;
    },
    setMultipleEmpInfo(info) {
      console.log("info:", info);
      info.forEach((v) => {
        v.id = "";
        v.enabledState = "yes";
      });
      console.log("this.row:", this.row);
      console.log("info:", info);
      let info2 = JSON.parse(JSON.stringify(info));
      this.row.empRelModelList.push(...info2);
      this.dialogVisibleEmp = false;
      console.log("this.row.empRelModelList:", this.row.empRelModelList);
      this.$forceUpdate();
    },
  },
};
</script>
<style>
.el-popper {
  width: auto;
}
</style>
<style lang='scss' scoped>
.scrollable-area {
    /* 设置溢出行为，使滚动条出现 */
    overflow-y: scroll;

    /* 针对Webkit内核的浏览器 */
    &::-webkit-scrollbar {
        /* 设置滚动条的宽度 */
        width: 8px;
    }

    /* 滚动条轨道 - 背景颜色/白底 */
    &::-webkit-scrollbar-track {
        background: #fff;
        border-radius: 10px;
    }

    /* 滚动条的滑块部分 */
    &::-webkit-scrollbar-thumb {
        background: rgba(144,147,153,.2);
        border-radius: 10px;
    }

    /* 当鼠标悬停在滚动条滑块上时改变颜色 */
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(144,147,153,.4);
    }
}
.scopeOfServices {
  width: 100%;
  height: 349px;
  border: 1px solid #E7E7E7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left_box {
    width: 200px;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    overflow-x: hidden;
    box-sizing: border-box;
    border-right: 1px solid #E7E7E7;
    .li {
      width: 160px;
      height: 34px;
      border-radius: 3px;
      font-weight: 400;
      font-size: 14px;
      color: #222222;
      line-height: 22px;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      p:first-child {
        width: 110px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p:last-child {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        font-size: 12px;
        color: #fff;
        background: #E50065;
        border-radius: 50%;
        text-align: center;
      }
    }
    .li.active {
      background: #FDECEE;
    }
  }
  
  .right_box_scope {
    width: calc(100% - 200px);
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
}
.scope-of-appointments-ul {
  li {
    padding-left: 40px;
    margin-bottom: 20px;
    .lable_h3 {
      position: relative;
      p {
        width: 500px;
        font-size: 14px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .lable_h3:before {
      content: '';
      width: 3px;
      height: 14px;
      background: #E50065;
      border-radius: 2px 0px 2px 0px;
      position: absolute;
      left: -10px;
      bottom: 2px;
    }
  }
}
.start_flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  width: 100%;
  height: calc(100vh - 130px);
  color: #222222;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .left_main {
    width: 360px;
    height: 100%;
    background: #fff;
    h2 {
        font-weight: 400;
        font-size: 16px;
        padding: 12px 20px;
        padding-bottom: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #CCCCCC;
      }
    .box {
      width: 100%;
      height: calc(100% - 79px);
      overflow-y: scroll;
      padding: 0 6%;
      box-sizing: border-box;
      .add_service_stores {
        width: 100%;
        display: block;
        margin-bottom: 20px;
      }
      .store_search {
        width: 100%;
      }
      ul {
        margin-top: 10px;
        li {
          min-height: 90px;
          cursor: pointer;
          padding: 0 0 0 10px;
          box-sizing: border-box;
          position: relative;
          line-height: 40px;
          overflow: hidden;
          border: 1px solid #eae6e6;
          margin-bottom: 10px;
          border-radius: 8px;
          .stores_name_box {
            display: flex;
            align-items: center;
            .store_name {
              margin-right: 4px;
            }
            .state {
              height: 18px;
              line-height: 18px;
              font-size: 12px;
              border: 1px solid #00AE26;
              color: #00AE26;
            }
          }
         
          .start_flex {
            width: 80%;
            display: block;
            p {
              max-width: 96px;
              display: inline-block;
              background: #d7f1ff;
              color: #0084CF;
              padding: 0 4px;
              box-sizing: border-box;
              border-radius: 4px;
              line-height: 20px;
              margin-right: 10px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .three {
            position: absolute;
            bottom: 10px;
            right: 10px;
            text-align: center;
            i {
              transform: rotate(90deg);
            }
            p {
              height: 20px;
              line-height: 20px;
              background: #fff;
            }
          }
        }
        // li:hover {
        //   background-color: #fff5f5;
        // }
        .active {
          background-color: #fff5f5;
        }
        .shutDown {
          opacity: 0.6;
          .stores_name_box {
            .state {
              border: 1px solid #333;
              color: #333;
            }
          }
        }
      }
    }
    .box::-webkit-scrollbar {
      width: 0;
    }
  }
  .right_box {
    width: calc(100% - 380px);
    height: 100%;
    margin-left: 10px;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    .headers {
      justify-content: space-between;
    }
  }
}

.priview {
  position: relative;
  width: 106px;
  height: 106px;
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }  
}
</style>